<!-- main-screen-style in style.css global -->

<section class="container-fluid main-screen">
  <app-web-navbar (searchProducts)="onSearchProduct($event)"></app-web-navbar>

  <!-- banners -->
  <div class="banner-container position-relative">
    <swiper [config]="mainBanner">
      <ng-template *ngFor="let banner of bannerValue" swiperSlide>
        <div class="position-relative text-center">
          <img [src]="banner.image" class="img-fluid banner-img" alt="Banner Image" />
        </div>
      </ng-template>
    </swiper>
    <div class="d-none d-lg-block">
      <div class="swiper-button-prev banner-swiper-button-prev"></div>
      <div class="swiper-button-next banner-swiper-button-next"></div>
    </div>
  </div>

  <!-- Category Section - Premium Design -->
  <section class="cat-section">
    <div class="container">
      <div class="cat-section-header text-center">
        <span class="cat-badge josefin-sans-medium">🍟 Our Menu</span>
        <!-- Category Search Input -->
        <div class="d-flex justify-content-center mt-3">
          <div class="search-container position-relative" style="width: 300px;">
            <input 
              type="text" 
              class="form-control premium-search-input" 
              placeholder="Search categories..." 
              style="border-radius: 50px; padding: 10px 40px 10px 20px; border: 1px solid rgba(255, 107, 53, 0.2); background: #fff;"
              [(ngModel)]="categorySearchQuery"
              (input)="onSearchCategory(categorySearchQuery)"
            >
            <i class="bi bi-search" style="position: absolute; right: 15px; top: 50%; transform: translateY(-50%); color: #999;"></i>
          </div>
        </div>
      </div>
      <div class="cat-carousel-wrap position-relative">
        <swiper [config]="categoryConfig">
          <ng-template swiperSlide>
            <div class="cat-card" [class.cat-active]="selectedCategoryId === 'all'" (click)="showAllCategories()">
              <div class="cat-card-inner">
                <div class="cat-img-wrap">
                  <img src="assets/img/new/athulya-agencies.png" loading="lazy" alt="All Categories">
                  <div class="cat-img-glow"></div>
                </div>
                <span class="cat-name josefin-sans-semibold">All</span>
              </div>
            </div>
          </ng-template>

          <ng-template swiperSlide *ngFor="let category of categoryDetails; let i = index">
            <div class="cat-card" [class.cat-active]="selectedCategoryId === category.categoryId"
              (click)="changeCategory(category.categoryId)">
              <div class="cat-card-inner">
                <div class="cat-img-wrap">
                  <img [src]="this.endpoint+'/api/category/images/get/'+category.categoryId" loading="lazy"
                    [alt]="category.categoryName">
                  <div class="cat-img-glow"></div>
                </div>
                <span class="cat-name josefin-sans-semibold">{{ category.categoryName }}</span>
              </div>
            </div>
          </ng-template>
        </swiper>

        <!-- Swiper Navigation -->
        <div class="swiper-button-prev cat-swiper-button-prev"></div>
        <div class="swiper-button-next cat-swiper-button-next"></div>
      </div>
    </div>
  </section>

  <!-- Why Choose Us Section - Premium Feature Cards -->
  <!-- <section class="why-choose-section">
    <div class="container">
      <div class="text-center mb-5">
        <p class="section-subtitle justify-content-center josefin-sans-medium">Why People Love Us</p>
        <h2 class="section-title-premium josefin-sans-bold">The Athulya Agencies Promise</h2>
      </div>
      <div class="row g-4">
        <div class="col-lg-3 col-md-6">
          <div class="feature-card">
            <div class="feature-icon">🌿</div>
            <h5 class="feature-title josefin-sans-bold">Fresh Ingredients</h5>
            <p class="feature-text josefin-sans-regular">Made with the finest quality ingredients, sourced fresh every
              day</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="feature-card">
            <div class="feature-icon">⚡</div>
            <h5 class="feature-title josefin-sans-bold">Fast Delivery</h5>
            <p class="feature-text josefin-sans-regular">Quick and reliable delivery right to your doorstep</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="feature-card">
            <div class="feature-icon">✨</div>
            <h5 class="feature-title josefin-sans-bold">Premium Quality</h5>
            <p class="feature-text josefin-sans-regular">Every product meets our strict quality standards</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="feature-card">
            <div class="feature-icon">💰</div>
            <h5 class="feature-title josefin-sans-bold">Best Prices</h5>
            <p class="feature-text josefin-sans-regular">Competitive pricing without compromising on quality</p>
          </div>
        </div>
      </div>
    </div>
  </section> -->

  <!-- top-products - Premium Product Cards -->
  <section class="py-5" id="products-section">
    <div class="container-fluid">
      <div class="row m-0 p-0">
        <div class="text-start section-header">
          <p class="section-subtitle josefin-sans-medium">Explore the Latest</p>
          <h1 class="section-title-premium josefin-sans-bold">Trending New Arrivals</h1>
        </div>
      </div>

      <!-- Products Display Section -->
      <div class="row mt-4 px-3">
        <!-- Products grid - when products exist -->
        <div class="row g-3" *ngIf="productDetails.length > 0">
          <div class="col-6 col-md-4 col-lg-3" *ngFor="let a of productDetails">
            <div class="product-card-premium h-100" (click)="productDetailViewNavigate(a.productId)">
              <div class="availability-badge" *ngIf="a.availability === 'Yes'">In Stock</div>
              <div class="product-bg rounded d-flex align-items-center justify-content-center overflow-hidden">
                <img [src]="getImageId(a.imageDetails)" loading="lazy" class="img-fluid product-image p-3"
                  [alt]="a.productName">
              </div>
              <div class="product-info-section">
                <h5 class="product-name josefin-sans-semibold">{{ a.productName }}</h5>
                <div class="product-badges">
                  <div class="weight-badge" *ngIf="a.totalQuantity">
                    <span class="weight-icon">⚖</span> {{ a.totalQuantity }} {{ a.unit || 'g' }}
                  </div>
                  <div class="pcs-badge" *ngIf="a.noOfPcsPerPkt">
                    <span class="pcs-icon">📦</span> {{ a.noOfPcsPerPkt }} pcs/pkt
                  </div>
                </div>
                <div class="price-row">
                  <span class="product-price josefin-sans-bold" *ngIf="a.srp">{{ a.srp }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Coming Soon - when no products found -->
        <div class="coming-soon-container" *ngIf="productDetails.length === 0">
          <div class="coming-soon-card">
            <div class="coming-soon-glow"></div>
            <div class="coming-soon-icons">
              <span class="coming-soon-icon icon-1">🍟</span>
              <span class="coming-soon-icon icon-2">🍔</span>
              <span class="coming-soon-icon icon-3">🍕</span>
              <span class="coming-soon-icon icon-4">🌮</span>
              <span class="coming-soon-icon icon-5">🧁</span>
            </div>
            <div class="coming-soon-illustration">
              <div class="chef-hat">👨‍🍳</div>
            </div>
            <div class="coming-soon-badge josefin-sans-medium">
              <span class="badge-dot"></span>
              Coming Soon
            </div>
            <div class="coming-soon-footer">
              <button class="coming-soon-btn josefin-sans-semibold" (click)="showAllCategories()">
                ← Explore All Products
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>

</section>

<!-- footer -->
<app-web-footer></app-web-footer>